import {
  IconDribbble,
  IconGithub,
  IconLinkedIn,
  IconTwitter,
  IconX,
} from '@/components/icons';

import { ROUTES } from '@/routes';

export const GLOBAL_NAV = [
  {
    label: 'Home',
    href: ROUTES.ROOT,
    className: 'sm:hidden',
  },
  {
    label: 'Work',
    href: ROUTES.WORK,
  },
  {
    label: 'About',
    href: ROUTES.ABOUT,
  },
  {
    label: 'Contact',
    href: ROUTES.CONTACT,
  },
];

export const SOCIAL_LINKS = [
  {
    icon: IconLinkedIn,
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/raylopezaleman/',
  },
  {
    icon: IconGithub,
    label: 'Github',
    href: 'https://github.com/raylopro',
  },
  {
    icon: IconDribbble,
    label: 'Dribbble',
    href: 'https://dribbble.com/raylopro',
  },
  {
    icon: IconX,
    label: 'Twitter',
    href: 'https://x.com/raylopro',
  },
  // {
  //   icon: IconTwitter,
  //   label: 'Twitter',
  //   href: 'https://twitter.com/raylopro',
  // },
  // {
  // 	icon: IconInstagram,
  // 	name: "Instagram",
  // 	href: "https://www.instagram.com/raylopro/",
  // },
];
